import React from 'react'
import { StyledIcon } from '../StyledIcon'

const FreeShippingIcon = ({ icon, size, customProps }) => (
  <StyledIcon
    viewBox="0 0 24 24"
    a11yTitle={icon}
    color="plain"
    size={size}
    {...customProps}
  >
    <g transform="translate(0.333333, 5.333333)">
      <path
        d="M14.8,0H3.4C3.1,0,2.7,0.4,2.6,0.7L0.8,11.1c-0.1,0.4,0.2,0.7,0.6,0.7h1.1C2.6,10.6,3.8,9.7,5,9.7
s2,1,1.8,2.2h6.7l2-11.1C15.5,0.4,15.2,0,14.8,0z"
      />
      <path
        d="M22.7,6.7l-2.8-4.5C19.8,2.1,19.7,2,19.5,2h-3.7l-1.7,9.8h0.8c0.2-1.2,1.4-2.2,2.5-2.2
c1.2,0,2,1,1.8,2.2h2c0.4,0,0.8-0.3,0.8-0.7l0.7-4C22.8,7,22.8,6.8,22.7,6.7z M16.3,6.5L17,3h2l2.2,3.5H16.3z"
      />
      <path
        d="M4.9,10.1c-1,0-1.9,0.8-2.1,1.8c-0.2,1,0.5,1.8,1.5,1.8c1,0,1.9-0.8,2.1-1.8S5.9,10.1,4.9,10.1z"
      />
      <path
        d="M17.4,10.1c-1,0-1.9,0.8-2.1,1.8c-0.2,1,0.5,1.8,1.5,1.8c1,0,1.9-0.8,2.1-1.8
C19,10.9,18.3,10.1,17.4,10.1z"
      />
    </g>
  </StyledIcon>
)

export default FreeShippingIcon
